import { Injectable } from '@angular/core';

import { ListRequest, ListResponse } from 'src/models';
import { Account } from 'src/models/accounts';

import { GenericObjectsService } from './generic-objects.service';

export interface AccountUserRole {
  accountId: string;
  userId: string;
  role: string;
  user?: {
    id: string;
    email: string;
    name: string;
    photo?: string;
  };
  account?: {
    id: string;
    name: string;
  };
}

export interface CreateAccountUserRoleRequest {
  email: string;
  userId?: string;
  name?: string;
  role?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AccountsService extends GenericObjectsService<Account> {
  protected baseUrl = '/accounts';

  listUserRoles(accountId: string, options: ListRequest = {}): Promise<ListResponse<Partial<AccountUserRole>>> {
    return this.apiService.postPromise(`/accounts/${accountId}/user-roles/list`, options);
  }

  addUserRole(accountId: string, data: CreateAccountUserRoleRequest): Promise<AccountUserRole> {
    return this.apiService.postPromise(`/accounts/${accountId}/user-roles`, data);
  }

  removeUserRole(accountId: string, userId: string): Promise<void> {
    return this.apiService.deletePromise(`/accounts/${accountId}/user-roles/${userId}`);
  }
}
